import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorWeathManagement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#TwoColorWeath__Management_svg__a)">
      <path
        fill={getTheme(props["data-theme"])}
        d="M16.207 10c0-.99.803-1.793 1.793-1.793h1c.99 0 1.793.803 1.793 1.793v10c0 .99-.803 1.793-1.793 1.793h-1c-.99 0-1.793-.803-1.793-1.793V10ZM18 9.793a.207.207 0 0 0-.207.207v10c0 .114.093.207.207.207h1a.207.207 0 0 0 .207-.207V10A.207.207 0 0 0 19 9.793h-1ZM2.207 15c0-.99.803-1.793 1.793-1.793h1c.99 0 1.793.803 1.793 1.793v5c0 .99-.803 1.793-1.793 1.793H4c-.99 0-1.793-.803-1.793-1.793v-5ZM4 14.793a.207.207 0 0 0-.207.207v5c0 .114.092.207.207.207h1A.207.207 0 0 0 5.207 20v-5A.207.207 0 0 0 5 14.793H4Zm7-4.586c-.99 0-1.793.803-1.793 1.793v8c0 .99.803 1.793 1.793 1.793h1c.99 0 1.793-.803 1.793-1.793v-8c0-.99-.803-1.793-1.793-1.793h-1ZM10.793 12c0-.114.093-.207.207-.207h1c.114 0 .207.093.207.207v8a.207.207 0 0 1-.207.207h-1a.207.207 0 0 1-.207-.207v-8Z"
      />
      <path
        fill="#F7A600"
        d="M11.331 2.461c0-.438.355-.793.793-.793h7.575a.793.793 0 0 1 .363 1.498L3.938 11.47a.793.793 0 1 1-.726-1.41l13.216-6.806h-4.304a.793.793 0 0 1-.793-.793Z"
      />
    </g>
    <defs>
      <clipPath id="TwoColorWeath__Management_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTwoColorWeathManagement;
